import { LoaderType, NextgenImage, useTranslation } from '@nextgen-web-framework/all';
import { getImageUrl } from '@commerce-order-webcomponents/sdk';
import { ORDER_NOT_FOUND_IMG } from '../../../common/constant';
import styles from './OrderNotFound.module.scss';
const OrderNotFound = () => {
  const t = useTranslation();

  return (
    <div className={styles['order-not-found-container']} data-testid="order-not-found-testid">
      <div className={styles['order-not-found-image-container']}>
        <NextgenImage
          src={getImageUrl(ORDER_NOT_FOUND_IMG)}
          loaderType={LoaderType.CONTENTSTACK}
          alt={t('order.deliveryTracking.orderNotFound')}
        />
      </div>
      <div className={styles['order-not-found-content-section']}>
        <div className={styles['order-not-found-content-title']}>{t('order.deliveryTracking.orderNotFound')}</div>
        <div className={styles['order-not-found-content-subtitle']}>{t('order.emptyPage.subHeadingText')}</div>
      </div>
    </div>
  );
};

export default OrderNotFound;
